
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"26","viewBox":"0 0 40 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V17C40 21.9706 35.9706 26 31 26H9C4.02944 26 0 21.9706 0 17V9Z","fill":"#EBC75B"}}),_c('path',{attrs:{"d":"M26.6797 5.40625H25.0625V4.5625C25.0625 4.25186 24.8107 4 24.5 4C24.1893 4 23.9375 4.25186 23.9375 4.5625V5.40625H16.0625V4.5625C16.0625 4.25186 15.8107 4 15.5 4C15.1893 4 14.9375 4.25186 14.9375 4.5625V5.40625H13.3203C12.0409 5.40625 11 6.44712 11 7.72656V19.6797C11 20.9591 12.0409 22 13.3203 22H26.6797C27.9591 22 29 20.9591 29 19.6797V7.72656C29 6.44712 27.9591 5.40625 26.6797 5.40625ZM27.875 19.6797C27.875 20.3399 27.3399 20.875 26.6797 20.875H13.3203C12.6601 20.875 12.125 20.3399 12.125 19.6797V10.3633C12.125 10.2662 12.2037 10.1875 12.3008 10.1875H27.6992C27.7963 10.1875 27.875 10.2662 27.875 10.3633V19.6797Z","fill":"white"}}),_c('path',{attrs:{"d":"M24.4532 12.2489C24.1375 11.917 23.6242 11.917 23.3085 12.2489L19.8332 15.8976L18.3818 14.3739C18.066 14.042 17.5528 14.042 17.2371 14.3739C16.921 14.7059 16.921 15.2439 17.2371 15.5758L19.2609 17.7008C19.4188 17.867 19.626 17.9499 19.8332 17.9499C20.0405 17.9499 20.2477 17.867 20.4056 17.7008L24.4532 13.4508C24.7693 13.1189 24.7693 12.5809 24.4532 12.2489Z","fill":"white"}})])
          )
        }
      }
    